import { render, staticRenderFns } from "./PageActionPanelModal.vue?vue&type=template&id=5857a534&"
import script from "./PageActionPanelModal.vue?vue&type=script&lang=js&"
export * from "./PageActionPanelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports